import EcoImg from 'eco-design/base/eco-img';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import css from './index.module.scss';
import { useLang } from '@/i18n';

export default function Screen5() {
    const { t } = useLang('theProductV2.Screen5');
    const webpOrJpg = useWebpOrJpg('#rapid-mag-Screen5-V2');

    return (
        <section
            className={`${css.comp}  GtmModuleData-section`}
            id="rapid-mag-Screen5-V2"
            data-section-id={'rapid-mag-Screen5-V2'}
            data-section-title={t('title')}
        >
            <div className="label">{t('label')}</div>
            <div className="title">{t('title')}</div>
            <div className="desc">{t('desc')}</div>
            <div className="img-box">
                <EcoImg
                    pc={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1762482233608/Screen5.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1762482237944/Screen5.webp',
                    )}
                    h5={webpOrJpg(
                        'https://websiteoss.ecoflow.com/upload/image/1762482233433/Screen5-h5.jpg',
                        'https://websiteoss.ecoflow.com/upload/image/1762482237615/Screen5-h5.webp',
                    )}
                />
            </div>
        </section>
    );
}
